import type { Service, Vendor, Deployment } from "./types";

const DEPLOYMENTS = [
  {
    vendor: "cartesia",
    service: "tts",
    model: null,
    trainingPolicy: "allowed",
    hasZdr: false,
    hasBaa: false,
  },
  {
    vendor: "elevenlabs",
    service: "tts",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: true,
    hasBaa: true,
  },
  // ElevenLabs confirmed our BAA covers only text to speech, speech to text and Agents.
  {
    vendor: "elevenlabs",
    service: "sts",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: true,
    hasBaa: false,
  },
  {
    vendor: "google",
    service: "llm",
    model: "gemini-3.1-flash-live-preview",
    trainingPolicy: "not_allowed",
    hasZdr: false,
    hasBaa: false,
  },
  {
    vendor: "assemblyai",
    service: "stt",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: false,
    hasBaa: true,
  },
  // ZDR holds only with mip_opt_out on every request (see buildDeepgramListenUrl).
  {
    vendor: "deepgram",
    service: "stt",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: true,
    hasBaa: false,
  },
  {
    vendor: "elevenlabs",
    service: "stt",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: true,
    hasBaa: true,
  },
  {
    vendor: "openai",
    service: "stt",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: true,
    hasBaa: true,
  },
  // No BAA or ZDR is recorded, so orgs that require either are blocked.
  {
    vendor: "cloudconvert",
    service: "file_conversion",
    model: null,
    trainingPolicy: "not_allowed",
    hasZdr: false,
    hasBaa: false,
  },
  // OpenAI Decisions API, which auto-advance uses to score end of turn (lib/interview/autoAdvance).
  // TODO(now): copied from the OpenAI STT row; verify our OpenAI contract covers the Decisions API on these terms.
  {
    vendor: "openai",
    service: "llm",
    model: "gpt-6-luna",
    trainingPolicy: "not_allowed",
    hasZdr: true,
    hasBaa: true,
  },
  // Other LLM deployments to be added...
] satisfies Deployment[];

export const selectDeployments = ({
  deployments,
  vendor,
  service,
  model,
}: {
  deployments: readonly Deployment[];
  vendor: Vendor;
  service: Service;
  model?: string;
}): Deployment[] => {
  const vendorDeployments = deployments.filter(
    (deployment) =>
      deployment.vendor === vendor && deployment.service === service
  );
  if (model === undefined) {
    return vendorDeployments;
  }

  const modelDeployments = vendorDeployments.filter(
    (deployment) => deployment.model === model
  );
  return modelDeployments.length > 0
    ? modelDeployments
    : vendorDeployments.filter((deployment) => deployment.model === null);
};

export const listDeploymentsForVendorServiceModel = ({
  vendor,
  service,
  model,
}: {
  vendor: Vendor;
  service: Service;
  model?: string;
}): Deployment[] =>
  selectDeployments({ deployments: DEPLOYMENTS, vendor, service, model });
